import View    from './view';

/**
 * poppet.Container
 * A view for holding other views.
 * @version 0.8.6
 */

const channelNav = Bb.Radio.channel('nav');

const Container = View.extend({

	// ------------------------------------------------
	// Setup
	// ------------------------------------------------

	className  : '',
	mainRegion : 'container',
	navHandler : 'external',

	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	/**
	 * Triggers when the view is rendered.
	 * @void
	 */
	onRender: function () {

		if ( ! this.isAttached() && this.checkRequirements() ) {
			this.attachView();
		}
	},

	/**
	 * Triggers when a childView requests a nav event.
	 * @param {string}  key      The event key, designating where to navigate.
	 * @param {array}   param    An array of params to format the key with.
	 * @param {object}  options  Navigation options.
	 */
	onChildviewNav: function ( key, param, options ) {
		if ( 'internal' === this.navHandler ) {
			this.settings({
				view: key,
			});
		} else {
			channelNav.trigger( key, param, options );
		}
	},


	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

	/**
	 * Sets the Container's settings, and triggers a new attachView.
	 * @param {object} options  A standard set of options, usually containing both model and view.
	 * @void
	 */
	settings: function ( options ) {
		View.prototype.settings.call( this, options );

		if ( this.options.navHandler ) {
			this.navHandler = this.options.navHandler;
		}

		if ( this.isRendered() && this.checkRequirements() ) {
			this.attachView();
		}
	},

	/**
	 * Checks if the layout is ready to attachView, overwrite this function to perform settings changes when low on data.
	 * @return {bool}  Defaults to true, overwrite to create false options, and settings changes per poppet.Container.
	 */
	checkRequirements: function () {
		return true;
	},

	/**
	 * The attachView function does the logic for attaching the correct view into the container.
	 * @void
	 */
	attachView: function () {
		//no default action
	},

});

export default Container;